import { type ReactNode } from 'react';
import { cn } from '@/utils/cn';

export function Card({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): ReactNode {
  return (
    <div
      className={cn(
        'rounded-lg border border-border-subtle bg-surface p-base',
        className
      )}
    >
      {children}
    </div>
  );
}
